var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#estimate-declined)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF2F2",
    d: "M11.402 8.781a.656.656 0 1 1-1.313 0V6.156a.656.656 0 0 1 1.313 0v2.625ZM9.652 8.854V6.478a.875.875 0 0 0-.484-.782l-.022-.011a1.75 1.75 0 0 0-.782-.185h-2.37a.875.875 0 0 0-.858.703l-.525 2.625a.875.875 0 0 0 .858 1.047h1.558v1.75c0 .483.391.875.875.875a.438.438 0 0 0 .437-.438v-.291c0-.379.123-.747.35-1.05l.613-.817a1.75 1.75 0 0 0 .35-1.05Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "estimate-declined"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclined);
export default __webpack_public_path__ + "static/media/declined.af3e0452ed211da10b5c80bf8b093e41.svg";
export { ForwardRef as ReactComponent };